import { render, staticRenderFns } from "./cashier.vue?vue&type=template&id=64f5623b&scoped=true&"
import script from "./cashier.vue?vue&type=script&lang=js&"
export * from "./cashier.vue?vue&type=script&lang=js&"
import style0 from "./cashier.vue?vue&type=style&index=0&id=64f5623b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5623b",
  null
  
)

export default component.exports